import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'You provide',
  sub: 'The project information',
  tone: 'bg-white text-plum border-plum/15',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'The prompt guides',
  sub: 'The AI through clear sections',
  tone: 'bg-plum text-white border-plum shadow-[0_0_0_1px_rgba(46,197,255,0.5),0_10px_30px_-12px_rgba(0,112,255,0.7)]',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'You review',
  sub: 'Customize and approve the result',
  tone: 'bg-white text-plum border-grape/30',
  iconTone: 'bg-lilac-soft text-grape'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="How a prompt works" data-id="element-241" data-mp="34hqzycy2homz">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-242" data-mp="1a4iyw3ji0gsw" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-60 ${n.tone}`} data-id="element-243" data-mp="1a5kmt8lm4xs1">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-244" data-mp="1f1b9actj3bli">
              <n.icon className="h-5 w-5" aria-hidden="true" data-id="element-245" data-mp="1a7p415pp29zq" />
            </span>
            <div className="min-w-0" data-id="element-246" data-mp="15agn18ga8c02">
              <p className="font-display text-base font-black" data-id="element-247" data-mp="10aual18a2zsb">{n.label}</p>
              <p className="text-xs leading-snug opacity-70" data-id="element-248" data-mp="10cnfoc38tby7">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-249" data-mp="1syzwhrb2iutq" />}
        </React.Fragment>)}
    </div>;
}